import {
  JiraFieldSchemeAriResourceOwner,
  JiraFieldSchemeAriResourceType
} from "./chunk-TNLQ2QQ5.mjs";
import {
  RegisteredAri
} from "./chunk-AB4PPISI.mjs";
import {
  AriParser
} from "./chunk-S7RIZVFI.mjs";

// src/jira/field-scheme/manifest.ts
var jiraFieldSchemeAriStaticOpts = {
  qualifier: "ari",
  platformQualifier: "cloud",
  cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
  // eslint-disable-line no-useless-escape
  resourceOwner: JiraFieldSchemeAriResourceOwner,
  resourceType: JiraFieldSchemeAriResourceType,
  resourceIdSlug: "activation/{activationId}/{fieldSchemeId}",
  resourceIdSegmentFormats: {
    activationId: /[a-zA-Z0-9\-]+/,
    // eslint-disable-line no-useless-escape
    fieldSchemeId: /[0-9]+/
    // eslint-disable-line no-useless-escape
  }
};

// src/jira/field-scheme/index.ts
var JiraFieldSchemeAri = class _JiraFieldSchemeAri extends RegisteredAri {
  constructor(opts) {
    super(opts);
    this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._fieldSchemeId = opts.resourceIdSegmentValues.fieldSchemeId;
  }
  get siteId() {
    return this._siteId;
  }
  get activationId() {
    return this._activationId;
  }
  get fieldSchemeId() {
    return this._fieldSchemeId;
  }
  static create(opts) {
    let derivedOpts = {
      qualifier: jiraFieldSchemeAriStaticOpts.qualifier,
      platformQualifier: jiraFieldSchemeAriStaticOpts.platformQualifier,
      cloudId: opts.siteId,
      resourceOwner: jiraFieldSchemeAriStaticOpts.resourceOwner,
      resourceType: jiraFieldSchemeAriStaticOpts.resourceType,
      resourceId: `activation/${opts.activationId}/${opts.fieldSchemeId}`,
      resourceIdSegmentValues: {
        activationId: opts.activationId,
        fieldSchemeId: opts.fieldSchemeId
      }
    }, ariOpts = AriParser.fromOpts(derivedOpts, jiraFieldSchemeAriStaticOpts);
    return new _JiraFieldSchemeAri(ariOpts);
  }
  static parse(maybeAri) {
    let opts = AriParser.fromString(maybeAri, jiraFieldSchemeAriStaticOpts);
    return new _JiraFieldSchemeAri(opts);
  }
  getVariables() {
    return {
      siteId: this.siteId,
      activationId: this.activationId,
      fieldSchemeId: this.fieldSchemeId
    };
  }
};

export {
  JiraFieldSchemeAri
};
